import React, { Component, createContext } from 'react';
import { Data } from '../data/Data';
import { Immocom } from '../specifique/immocom';

export const PerimetreContext = createContext();

class PerimetreProvider extends Component {

    static defaultState = {
        idRegion: 0,
        idAgence: 0,
        idProgramme: 0,
        idOperation: 0,
        idRegionAdministrative: 0,
        idDepartementAdministratif: "0",
        idVilleAdministrative: "0",
    };

    constructor(props) {
        super(props);
        this.state = { ...PerimetreProvider.defaultState };
    };

    // Passer en paramètre les ids à mettre à jour ; exemple : { idRegion = 101, idOperation = 414 }
    // KP - 2601 - 02/01/2023 : on omet les valeurs falsy (en particulier pour ne pas traiter les undefined et ne mettre à jour que les valeurs qui nous intéressent)
    _setPerimetre = (ids, onSuccess, onError) => {
        const truthyIds = Object.entries(ids).reduce((memo, [key, value]) => (!!value || value === 0 ? (memo[key] = value, memo) : memo), {});
        const newPerimetre = { ...this.state, ...truthyIds };
        Data._renseignementPerimetre(newPerimetre).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const callback = !!onSuccess && typeof (onSuccess) === "function" ? onSuccess : undefined;
                this.setState(truthyIds, callback);
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                if (!!onError && typeof (onError) === "function")
                    onError(retourVerif, responseFetch);
            }
        });
    };

    componentDidMount = () => {
        Data._verificationSiPerimetreExiste().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const valeurRetour = responseFetch.reponseAPIobjet;
                const idOperation = valeurRetour[0];
                const idAgence = valeurRetour[1];
                const idRegion = valeurRetour[2];
                const idProgramme = valeurRetour[7];
                const idRegionAdministrative = valeurRetour[4];
                const idDepartementAdministratif = valeurRetour[5];
                const idVilleAdministrative = valeurRetour[6];

                this._setPerimetre({ idRegion, idAgence, idProgramme, idOperation, idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative });
            }
            else Immocom.onTraitementErreurAvecState(this, { ...PerimetreProvider.defaultState }, retourVerif, responseFetch);
        });
    };

    render = () => {
        const { children } = this.props;
        const perimetre = { ...this.state };

        return <PerimetreContext.Provider value={{ perimetre, setPerimetre: this._setPerimetre }}>
            {children}
        </PerimetreContext.Provider>;
    };

};

export default PerimetreContext;
export { PerimetreProvider };